export default __webpack_public_path__ + "static/media/gate2.af1b82f3.png";